import { Phone, MessageCircle, FileText } from "lucide-react";
import { PHONE_TEL_LINK, WHATSAPP_LINK } from "@/constants/business";
import { useDialogs } from "@/context/DialogsContext";

export default function MobileStickyBar() {
  const { requestEstimate } = useDialogs();

  const items = [
    { icon: Phone, label: "Appeler", href: PHONE_TEL_LINK, testid: "sticky-call-button" },
    { icon: MessageCircle, label: "WhatsApp", href: WHATSAPP_LINK, testid: "sticky-whatsapp-button", external: true },
    { icon: FileText, label: "Estimation", onClick: () => requestEstimate({ source: "barre-mobile-estimation" }), testid: "sticky-quote-button" },
  ];

  return (
    <div
      data-testid="mobile-sticky-bar"
      className="fixed bottom-0 left-0 right-0 z-50 md:hidden bg-navy border-t border-white/10 grid grid-cols-3 shadow-[0_-4px_20px_rgba(0,0,0,0.2)]"
      style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
    >
      {items.map((item) =>
        item.href ? (
          <a
            key={item.testid}
            href={item.href}
            target={item.external ? "_blank" : undefined}
            rel={item.external ? "noopener noreferrer" : undefined}
            data-testid={item.testid}
            className="flex flex-col items-center justify-center gap-1 py-2.5 text-white text-[11px] font-semibold active:bg-white/10 transition-colors"
          >
            <item.icon className="w-5 h-5" />
            {item.label}
          </a>
        ) : (
          <button
            key={item.testid}
            onClick={item.onClick}
            data-testid={item.testid}
            className="flex flex-col items-center justify-center gap-1 py-2.5 text-white text-[11px] font-semibold active:bg-white/10 transition-colors"
          >
            <item.icon className="w-5 h-5" />
            {item.label}
          </button>
        )
      )}
    </div>
  );
}
